<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Insurance Invoices",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      modal_id: "",
      test: null,
      ledgerDetails: {
        detail: [],
        company: "",
      },

      title: "Insurance Invoices",
      items: [
        {
          text: "Account Section",
          href: "#/",
        },
        {
          text: "Insurance Invoices",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "company.name",
          sortable: true,
          label: "COMPANY",
        },
        {
          key: "company.contact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "company.email",
          sortable: true,
          label: "EMAIL",
        },
        {
          key: "invoiceNo",
          sortable: true,
          label: "INVOICE No.",
        },
        {
          key: "dateFrom",
          sortable: true,
          label: "FROM	",
        },
        {
          key: "dateTo",
          sortable: true,
          label: "TO",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
        {
          key: "paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      errors: {
        modeError: "",
      },
      generateinvoice: {
        company: "",
        from: "",
        to: "",
        due: "",
      },
      clearBlance: {
        title: "",
        InsuranceInvoices_company: "",
        invoiceNo: "",
        balance: "",
        total: "",
        paid: "",
        invoice_id: "",
        paymode: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapState("insurance", ["print_ins_reciept"]),
    ...mapGetters("insurance", [
      "InsuranceInvoices",
      "InsuranceCompanies",
      "InsuranceInvoiceStatus",
    ]),
    ...mapGetters("payments", ["PaymentModes", "ClearStatus"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.InsuranceInvoices ? this.InsuranceInvoices.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.InsuranceInvoices ? this.InsuranceInvoices.length : 1;
  },
  watch: {
    print_ins_reciept(newValue) {
      if (newValue == true) {
        this.$router.push(`/insurance/pay_reciept/${btoa(this.clearBlance.invoice_id)}`);
      }
    },
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
          this.closeMode(this.modal_id);
          let dd = {
            company: "",
            from: "",
            to: "",
            due: "",
          };
          this.generateinvoice = dd;
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    yes() {
      alert("comming soon");
    },

    ...mapActions({
      FetchInsuranceInvoices: "insurance/fetchInsuranceInvoices",
      FetchInsuranceCompanies: "insurance/fetchInsuranceCompanies",
      MakeInsurancePayment: "insurance/makeInsurancePayment",
      GenerateInsuranceInvoice: "insurance/generateInsuranceInvoice",
      FetchPaymentModes: "payments/fetchPaymentModes",
    }),

    SetCompanyPrev() {
      let preDetails = this.InsuranceInvoices.filter((element) => {
        return element.company.id == this.generateinvoice.company;
      });
      if (preDetails.length) {
        let compodj = preDetails[0];
        this.generateinvoice.from = compodj.next_inv_from;
      }
    },

    GenerationFunction() {
      this.modal_id = "generate_invoice";
      this.GenerateInsuranceInvoice(this.generateinvoice);
    },
    // LEDGER MODEL
    viewLedger(data) {
      let ledger = {
        detail: data.ledgers,
        company: data.company.name,
        invoice_id: data.id,
        total: data.amount,
        paid: data.paid,
        balance: this.remove_commas(data.balance),
      };
      this.ledgerDetails = ledger;
    },

    // END LEDGER MODEL
    // CLEAR BALANCE
    SetBalanceClear(data) {
      this.test = data;
      let invdata = {
        paymode: "",
        title: `Make Payments for ${data.company.name} Invoice ${data.invoiceNo}`,
        InsuranceInvoices_company: data.company.name,
        invoiceNo: data.invoiceNo,
        balance: data.balance,
        total: data.amount,
        paid: data.paid,
        invoice_id: data.id,
      };
      this.clearBlance = invdata;
    },

    // CALL BACK END
    ClearBalnceF() {
      this.modal_id = "clearvalance";
      this.MakeInsurancePayment(this.clearBlance);
    },
    // END CLEAR BALANCE
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },

    // REMOVE COMMA SEPERTORS
    remove_commas(data) {
      var removed = data.replace(/,/g, "");
      return parseInt(removed);
    },
    //END  REMOVE
    reprintReciept(ledger) {
      this.$router.push(`/insurance/ins_reciept_reprint/${btoa(ledger)}`);
    },
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created() {
    this.FetchInsuranceInvoices();
    this.FetchInsuranceCompanies();
    this.FetchPaymentModes();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="d-print-none">
      <div class="float-end">
        <button
          v-if="user_permissions ? user_permissions.generate_invoice : false"
          v-b-modal.generate_invoice
          class="btn btn-primary mb-2 float-end"
        >
          Generate Invoice <i class="fa fa-plus-circle"></i>
        </button>
      </div>
    </div>
    <div class="d-print-none">
      <button @click="$router.go(-1)" class="btn btn-success mb-2">
        <i class="fas fa-arrow-circle-left"></i> Go Back
      </button>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="InsuranceInvoices ? InsuranceInvoices : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(balance)="data">
                  {{ data.item.balance }}
                  <button
                    v-b-modal.clearvalance
                    v-if="
                      remove_commas(data.item.balance) > 0 &&
                      user_permissions.clear_payments
                    "
                    class="btn btn-success btn-sm"
                    @click="SetBalanceClear(data.item)"
                  >
                    Pay
                  </button>
                  <button
                    v-else-if="
                      remove_commas(data.item.balance) > 0 &&
                      !user_permissions.clear_payments
                    "
                    class="btn btn-success btn-sm"
                    disabled
                    @click="SetBalanceClear(data.item)"
                  >
                    Pay
                  </button>
                </template>
                <template #cell(actions)="data">
                  <button
                    v-b-modal.modal-lg
                    class="btn btn-primary btn-sm m-1"
                    @click="viewLedger(data.item)"
                  >
                    Ledger
                  </button>
                  <router-link
                    v-if="data.item.invoice != 0 && user_permissions.view_invoice"
                    :to="{
                      name: 'Insurance_Invoice_Details',
                      params: { invoice_id: data.item.id },
                    }"
                  >
                    <button class="btn btn-info btn-sm m-1">Details</button>
                  </router-link>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <!-- LEDGER MODEL -->
            <div class="row">
              <div class="col-sm-6 col-md-4 col-xl-3">
                <div class="my-4 text-center">
                  <b-modal
                    id="modal-lg"
                    size="lg"
                    :title="'Payment Ledger For ' + ledgerDetails.company"
                    title-class="font-18"
                    hide-footer
                  >
                    <div class="table-responsive">
                      <table
                        class="table table-bordered border-primary mb-0"
                        v-if="ledgerDetails.detail ? ledgerDetails.detail.length : 0"
                      >
                        <thead>
                          <tr>
                            <th>DATE</th>
                            <th>AMOUNT PAID</th>
                            <th>BALANCE</th>
                            <th>ACTION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(ledger, index) in ledgerDetails.detail"
                            :key="index"
                          >
                            <td>{{ ledger.date }}</td>
                            <td>{{ thousandSeprator(ledger.amount) }}</td>
                            <td>{{ thousandSeprator(ledger.balance) }}</td>
                            <td>
                              <button
                                v-if="user_permissions.view_invoice"
                                @click="reprintReciept(ledger.id)"
                                class="btn btn-success btn-sm"
                              >
                                <i class="fa fa-print"></i> Reprint
                              </button>
                              <button
                                v-else
                                disabled
                                @click="reprintReciept(ledger.id)"
                                class="btn btn-success btn-sm"
                              >
                                <i class="fa fa-ban"></i> Reprint
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p v-else class="text-danger text-center">
                        No payments recieved from <b>{{ ledgerDetails.company }}</b> for
                        this invoice
                      </p>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- END LEDGER MODEL -->

            <!-- GENERATE INVOICE -->
            <b-modal
              id="generate_invoice"
              title="Generate Insurance Invoice"
              ok-title="Generate"
              hide-footer
            >
              <b-form-group label="Insurance company">
                <model-list-select
                  @input="SetCompanyPrev()"
                  :list="InsuranceCompanies ? InsuranceCompanies : []"
                  v-model="generateinvoice.company"
                  option-value="id"
                  option-text="companyName"
                  placeholder="select insurance company"
                >
                </model-list-select>
              </b-form-group>
              <b-form-group label="From">
                <b-form-input type="date" v-model="generateinvoice.from"></b-form-input>
              </b-form-group>
              <b-form-group label="To">
                <b-form-input type="date" v-model="generateinvoice.to"></b-form-input>
              </b-form-group>
              <b-form-group label="Due Date">
                <b-form-input type="date" v-model="generateinvoice.due"></b-form-input>
              </b-form-group>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary float-start"
                  @click="closeMode('generate_invoice')"
                >
                  cancel
                </button>
                <button
                  v-if="
                    generateinvoice.company &&
                    generateinvoice.from &&
                    generateinvoice.to &&
                    generateinvoice.due
                  "
                  @click="GenerationFunction()"
                  type="submit"
                  class="btn btn-success"
                >
                  SUBMIT
                  <b-spinner
                    v-if="InsuranceInvoiceStatus"
                    style="float: right"
                    small
                    variant="light"
                    role="status"
                    t
                  ></b-spinner>
                  <i v-else class="fa fa-check"></i>
                </button>
                <button
                  title="Fill all fields"
                  v-else
                  type="submit"
                  disabled
                  class="btn btn-primary"
                >
                  SUBMIT
                  <i class="fa fa-check"></i>
                </button>
              </div>
            </b-modal>

            <!-- ENDE GENERATE INVOICE -->

            <!-- CLEAR BALANCE MODEL -->

            <b-modal id="clearvalance" :title="clearBlance.title" hide-footer>
              <b-form-group label="Amount">
                <b-form-input
                  placeholder="Enter amount to clear"
                  type="text"
                  v-model="clearBlance.balance"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Payment mode">
                <model-list-select
                  :list="PaymentModes ? PaymentModes : []"
                  v-model="clearBlance.paymode"
                  option-value="id"
                  option-text="mode"
                  placeholder="select payment mode"
                >
                </model-list-select>
                <div class="text-danger" v-if="errors.modeError">
                  <em>{{ errors.modeError }}</em>
                </div>
              </b-form-group>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary float-start"
                  @click="closeMode('clearvalance')"
                >
                  cancel
                </button>
                <button
                  v-if="clearBlance.paymode && clearBlance.balance"
                  @click="ClearBalnceF()"
                  type="button"
                  class="btn btn-success"
                >
                  SUBMIT
                  <b-spinner
                    v-if="InsuranceInvoiceStatus"
                    style="float: right"
                    small
                    variant="light"
                    role="status"
                    t
                  ></b-spinner>
                  <i v-else class="fa fa-check"></i>
                </button>
                <button
                  title="Fill all fields"
                  v-else
                  type="button"
                  disabled
                  class="btn btn-primary"
                >
                  SUBMIT
                  <i class="fa fa-check"></i>
                </button>
              </div>
            </b-modal>

            <!-- END CLEAR MODEL -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
